<ngb-carousel [interval]="5000" [showNavigationArrows]="false" [showNavigationIndicators]="false" class="h-100 w-100">
  <ng-template ngbSlide *ngFor="let campaign of campaigns" class="h-100 w-100">
    <sb-card>
      <div card-img class="card-img fill">
        <ng-container *ngIf="campaign?.preview && campaign?.preview?.length > 0">
          <ng-container
            *ngIf="campaign?.preview ? campaign?.preview[0]?.contentType?.includes('video') : false; else stillImageContainer">
            <video style="width: 100%; height:100%; background: rgba(153, 157, 174, 0.1);" autoplay playsInline
                   muted loop onloadedmetadata="this.muted=true">
              <source src="{{campaign?.preview[0]?.url+'?thumbnail=M'}}"/>
            </video>
          </ng-container>
          <ng-template #stillImageContainer>
            <div style="width: 100%; height:100%; background: rgba(153, 157, 174, 0.1);">
              <div
                [style.backgroundImage]="campaign?.preview[0]?.stillImage ? 'url(' + campaign?.preview[0]?.stillImage+'?thumbnail=M)' : ''"
                style="width: 100%; height: 100%; background-size: contain; background-repeat: no-repeat; background-position: center;">
              </div>
            </div>
          </ng-template>
        </ng-container>
        <ng-container *ngIf="!(campaign?.preview)">
          <div class="flex-fill" style="width: 100%; height:100%; background: rgba(153, 157, 174, 0.1);">
          </div>
        </ng-container>
      </div>
      <div card-body>
        <div class="widget no-border">
          <div class="widget__info">
            <div class="widget__item">
            <span class="widget__title">
              <h5>{{campaign?.name}}</h5>
            </span>
              <span class="widget__subtitle no-wrap">
              {{'lang.globals.commercials' | translate}}:
                <span *ngIf="campaign.commercialCount?.Future"
                      class="badge blue ml-1">{{campaign.commercialCount?.Future?.toString()}} {{'lang.globals.planned' | translate}}</span>
                <span *ngIf="campaign.commercialCount?.Present"
                      class="badge green ml-1">{{campaign.commercialCount?.Present?.toString()}} {{'lang.globals.running' | translate}}</span>
                <span *ngIf="campaign.commercialCount?.Past"
                      class="badge grey ml-1">{{campaign.commercialCount?.Past?.toString()}} {{'lang.globals.expired' | translate}}</span>
                <span *ngIf="campaign.commercialCount?.Unknown"
                      class="badge grey ml-1">{{campaign.commercialCount?.Unknown?.toString()}} {{'lang.globals.noTiming' | translate}}</span>
            </span>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <sb-action-required class="mr-4" [bookingStatus]="campaign.bookingStatus"></sb-action-required>
          </div>
          <!--
          <span class="badge" [SbBookingStatus]="campaign">{{'lang.globals.running' | translate}}</span>
          -->
        </div>
        <div class="widget pt-5 align-items-center no-border flex-fill">
          <div class="widget__item">
            <div class="widget_details">
            <span class="widget__title">
              {{'lang.dashboard.startDate' | translate}}
            </span>
              <span
                class="badge blue">{{ campaign?.from ? (campaign?.from?.toString() | date : 'dd.MM.yy') : '-'}}</span>
            </div>
          </div>
          <div class="widget__item">
            <div class="widget_details">
            <span class="widget__title">
              {{'lang.dashboard.dueDate' | translate}}
            </span>
              <span class="badge red">{{ campaign?.till ? (campaign?.till.toString() | date : 'dd.MM.yy') : '-'}}</span>
            </div>
          </div>
          <div class="widget__item flex-fill">
            <div class="widget_details flex-fill">
              <div class="flex-fill">
                <sb-progressbar [width]="util.getTimeframePercentage(campaign?.from,campaign?.till)">
                </sb-progressbar>
              </div>
            </div>
          </div>
        </div>
        <div class="widget pt-5">
          <div class="widget__actions">
            <a [sbRouterLink]="util.RoutingID.commercials" [pathParams]="[{id: 'campaignID', value: campaign?.id}]">
              <sb-button classes="btn-primary btn-sm">{{'lang.dashboard.viewCampaign' | translate}}</sb-button>
            </a>
          </div>
        </div>

      </div>
    </sb-card>
  </ng-template>
</ngb-carousel>
